import type { BlockSpec } from '@blocksuite/block-std';
import {
  AttachmentBlockService,
  AttachmentBlockSpec,
} from '@blocksuite/blocks';

class CustomAttachmentBlockService extends AttachmentBlockService {
  override mounted(): void {
    // Remove size restriction
    this.maxFileSize = Infinity;
    super.mounted();
  }
}

export const CustomAttachmentBlockSpec: BlockSpec = {
  ...AttachmentBlockSpec,
  service: CustomAttachmentBlockService,
};
